module.exports = __webpack_public_path__ + "static/img/indexItem.21efe163.png";